import { createContext, useContext } from 'react';
import type { DrawingDocument } from '@peruselab/structure-editor/model';

/**
 * #1178 (owner, 2026-11-02): the result card that is Identical to a molecule on the paper is drawn
 * from that piece of the paper, so the card, the paper and every export show the same thing -- its
 * crossed double bonds, its E/Z, its layout. Keyed by the matched molecule's id.
 */
export const PaperPiecesContext = createContext<Readonly<Record<string, DrawingDocument>>>({});

export function usePaperPiece(moleculeId: string, identical: boolean): DrawingDocument | undefined {
  const pieces = useContext(PaperPiecesContext);
  return identical ? pieces[moleculeId] : undefined;
}
